<template>
  <nav class="navbar">
    <div class="container">
      <!-- Logo and Title -->
      <div class="logo-title">
        <router-link to="/">
          <img class="logo-img" src="/icon.png" alt="htj">
        </router-link>
        <h1 class="site-title">How to Jeremy</h1>
      </div>

      <!-- Navigation Links -->
      <ul class="nav-links">
        <li>
          <router-link to="/" class="nav-link">Home</router-link>
        </li>
	<li>
          <a href="/portfolio" class="nav-link">Portfolio</a>
        </li>
        <li>
          <a href="/book/index.html" class="nav-link">Book</a>
        </li>
        <!--
        <li>
          <router-link to="/blog" class="nav-link">Blog</router-link>
        </li>
        -->
        <li>
          <a href="https://www.linkedin.com/in/jerschwartz/" class="icon-link" target="_blank">
            <font-awesome-icon :icon="['fab', 'linkedin']" />
          </a>
        </li>
        <li>
          <a href="https://www.instagram.com/howtojeremy/" class="icon-link" target="_blank">
            <font-awesome-icon :icon="['fab', 'instagram']" />
          </a>
        </li>

 <li>
        <a href="https://www.flickr.com/photos/21260037@N05/" target="_blank" rel="noopener noreferrer" aria-label="Flickr">
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 448 512"
    width="24"
    height="24"
    aria-hidden="true"
    focusable="false"
  >

    
    <!-- Left circle -->
    <path fill="#ffffff" d="M144.5 319c-35.1 0-63.5-28.4-63.5-63.5s28.4-63.5 63.5-63.5 63.5 28.4 63.5 63.5-28.4 63.5-63.5 63.5z"/>
    
    <!-- Right circle -->
    <path fill="#ffffff" d="M303.5 319c-35.1 0-63.5-28.4-63.5-63.5s28.4-63.5 63.5-63.5 63.5 28.4 63.5 63.5-28.4 63.5-63.5 63.5z"/>
  </svg>
</a>
 </li>

 
        <li>
          <a href="https://bsky.app/profile/howtojeremy.bsky.social" class="icon-link" target="_blank">
            <svg class="svg-inline--fa fa-instagram" aria-hidden="true" focusable="false" data-prefix="fab" data-icon="instagram" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
              <path fill="currentColor" d="M111.8 62.2C170.2 105.9 233 194.7 256 242.4c23-47.6 85.8-136.4 144.2-180.2c42.1-31.6 110.3-56 110.3 21.8c0 15.5-8.9 130.5-14.1 149.2C478.2 298 412 314.6 353.1 304.5c102.9 17.5 129.1 75.5 72.5 133.5c-107.4 110.2-154.3-27.6-166.3-62.9c-1.7-4.9-2.6-7.8-3.3-7.8s-1.6 3-3.3 7.8c-12 35.3-59 173.1-166.3 62.9c-56.5-58-30.4-116 72.5-133.5C100 314.6 33.8 298 15.7 233.1C10.4 214.4 1.5 99.4 1.5 83.9c0-77.8 68.2-53.4 110.3-21.8z"/>
            </svg>
          </a>
        </li>
      </ul>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'PageHeader'
}
</script>

<style scoped>
  /*#f97316;*/
  
.navbar {
  background-color: #ffac1c;
  color: white;
  padding: 1rem;
}

.container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-width: 1200px;
  margin: 0 auto;
}

.logo-title {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.logo-img {
  height: 2.5rem;
  width: 2.5rem;
  padding: 0.25rem;
  background-color: white;
}

.site-title {
  font-size: 1.25rem;
  font-weight: 600;
}

.nav-links {
  display: flex;
  list-style: none;
  padding: 0;
  gap: 1rem;
  margin-top: 0.5rem;
}

.nav-link {
  padding: 0.25rem 0.5rem;
  border-radius: 4px;
  text-decoration: none;
  color: white;
  transition: background-color 0.2s ease;
}

.nav-link:hover {
  background-color: #fb923c;
}

.icon-link {
  color: white;
  text-decoration: none;
  transition: opacity 0.2s ease;
}

.icon-link:hover {
  opacity: 0.7;
}

.svg-inline--fa {
  width: 1rem;
  height: 1rem;
}  
</style>
